import { ComponentPropsWithoutRef, ElementType, ReactNode, Ref } from 'react';
import { useFela } from 'react-fela';
import theme from '../../../utils/theme';
import { FelaExtend } from '../../../types/fela';

type InputProps = {
  children?: ReactNode;
  className?: string;
  innerRef?: Ref<unknown>;
  as?: ElementType;
  extend?: FelaExtend;
  autoFocus?: boolean;
  type?: string;
} & Record<string, unknown>;

const Input = ({
  children,
  className,
  innerRef,
  as: As = 'input',
  extend,
  autoFocus,
  type,
  ...props
}: InputProps) => {
  const { css } = useFela(props);

  const defaultStyle = {
    backgroundColor: theme.colors.lightGrey,
    borderRadius: theme.layout.borderRadius,
    borderWidth: 0,
    padding: `${theme.layout.grid}px ${1 * theme.layout.grid}px`,
    width: '100%',
    height: 35,
  };

  return (
    <As
      {...(props as ComponentPropsWithoutRef<ElementType>)}
      ref={innerRef}
      className={css(defaultStyle, extend as object) + (className ? ' ' + className : '')}
      type={type || 'text'}
      autoComplete="new-password"
    >
      {children}
    </As>
  );
};

export default Input;
